/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

declare const execTest1: any ;
@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(private analytics: AnalyticsService,public translate:TranslateService,private cookieService: CookieService) {
    translate.addLangs(['fr','ar']);  
    translate.setDefaultLang('ar');
    const browserLang=translate.getBrowserLang();
    translate.use(browserLang.match(/fr|ar/) ? browserLang :'ar');
  }

  ngOnInit(): void {
    this.analytics.trackPageViews();
    // this.cookieService.set("SameSite","None",new Date().getTime()+(7*24*3600),"/","127.0.0.1",false,'None')
    // this.cookieService.set("key", "value", new Date().getTime()+(7*24*3600), "/; SameSite=None; Secure");
  }
  onClick() {
    execTest1();
  }
}

